module.exports = __webpack_public_path__ + "255ef2cc6000fd099c2068523f1bca0a.pdf";